import { render } from "./PopularBets.vue?vue&type=template&id=7503a575&scoped=true"
import script from "./PopularBets.vue?vue&type=script&lang=js"
export * from "./PopularBets.vue?vue&type=script&lang=js"

import "./PopularBets.vue?vue&type=style&index=0&id=7503a575&scoped=true&lang=css"
/* custom blocks */
import block0 from "./PopularBets.vue?vue&type=custom&index=0&blockType=span"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7503a575"]])

export default __exports__